import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import GoBack from "../../../component/molecules/goBack";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";
import { errorHandler } from "../../../util/errorHandler";
import { formatPhoneNumber } from "../../../util/formatNumber";
import { route } from "../../../router/route";
import MembershipApplyApi from "../../../api/membershipApply.api";

const UserMembershipWaitingListDetail = () => {
  let { id } = useParams();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_membership_info)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    getUserInfoFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getUserInfoFunc = async () => {
    try {
      const response = (await MembershipApplyApi.getDetail(id)).data.data
        .content;

      setUserInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            {isWriteAuthority && (
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: 12,
                }}
              >
                <GrayBtn
                  onClick={() => {
                    setSMSPopupOpen(true);
                  }}
                >
                  SMS 보내기
                </GrayBtn>
              </div>
            )}
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 30,
              }}
            >
              <DetailPageTitle
                style={{
                  marginBottom: 12,
                }}
              >
                멤버십 대기명단
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    이름
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.name || "-"}</DetailFormText>
                </DetailPageForm>

                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    아이디(이메일)
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.email || "-"}</DetailFormText>
                </DetailPageForm>

                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    인지경로
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.entrancePath || "-"}
                  </DetailFormText>
                </DetailPageForm>

                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    핸드폰번호
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.phoneNumber
                      ? formatPhoneNumber(userInfo.phoneNumber)
                      : "-"}
                  </DetailFormText>
                </DetailPageForm>

                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    현재 글쓰기를 하고 있는 방식
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.question1Answer || "-"}
                  </DetailFormText>
                </DetailPageForm>

                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    당신이 가장 원하는 것
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.question2Answer || "-"}
                  </DetailFormText>
                </DetailPageForm>

                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    현재 직업
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.question3Answer || "-"}
                  </DetailFormText>
                </DetailPageForm>

                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    연령대
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.question4Answer || "-"}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    신청일시
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.createdAt
                      ? moment(userInfo.createdAt).format("YYYY-MM-DD HH:mm")
                      : "-"}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    인증완료일시
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.certificationCompleteAt
                      ? moment(userInfo.certificationCompleteAt).format(
                          "YYYY-MM-DD HH:mm"
                        )
                      : "-"}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    marginTop: 13,
                    border: "none",
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 195,
                    }}
                  >
                    라이팅크루 멤버가 되고 싶으신 이유
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.question5Answer || "-"}
                  </DetailFormText>
                </DetailPageForm>
              </div>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={[userInfo]}
          getMemberList={getUserInfoFunc}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={[userInfo]}
          getMemberList={getUserInfoFunc}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}
    </>
  );
};

export default UserMembershipWaitingListDetail;
